/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RecruiteeConnectionConfigFromJSON, RecruiteeConnectionConfigToJSON, } from './RecruiteeConnectionConfig.js';
/**
 * Check if a given object implements the UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig interface.
 */
export function instanceOfUpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig(value) {
    if (!('defaultMessageId' in value) || value['defaultMessageId'] === undefined)
        return false;
    if (!('senderEmployerId' in value) || value['senderEmployerId'] === undefined)
        return false;
    return true;
}
export function UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfigFromJSON(json) {
    return UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfigFromJSONTyped(json, false);
}
export function UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'defaultMessageId': json['defaultMessageId'],
        'senderEmployerId': json['senderEmployerId'],
        'config': json['config'] == null ? undefined : RecruiteeConnectionConfigFromJSON(json['config']),
    };
}
export function UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfigToJSON(json) {
    return UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfigToJSONTyped(json, false);
}
export function UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'defaultMessageId': value['defaultMessageId'],
        'senderEmployerId': value['senderEmployerId'],
        'config': RecruiteeConnectionConfigToJSON(value['config']),
    };
}
